"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var css_1 = require("@emotion/css");
var Box_1 = require("../Box");
var settings_1 = require("../settings");
/** add icon css style to document */
var link;
if (typeof document !== 'undefined') {
    // for hot reload, element may already exist
    link = document.getElementById('ff-ui-icon-style');
    if (!link) {
        link = document.createElement('link');
        link.setAttribute('id', 'ff-ui-icon-style');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.href = settings_1.settings.REACT_APP_CDN_DOMAIN + "/assets/fonts/ff-icons/v" + settings_1.settings.FF_ICONS_VERSION + "/style.css";
        document.head.appendChild(link);
    }
}
var IconContainer = (0, Box_1.createBasicComponent)({
    fontFamily: 'ff-icons !important',
    speak: 'none',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontVariant: 'normal',
    textTransform: 'none',
    lineHeight: 1,
    fontSize: '16px',
    /* Better Font Rendering =========== */
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale'
});
IconContainer.defaultProps = { as: 'i' };
var Icon = function (props) {
    var _a = props.name, name = _a === void 0 ? '' : _a, _b = props.className, className = _b === void 0 ? '' : _b, rest = __rest(props, ["name", "className"]);
    return (react_1.default.createElement(IconContainer, __assign({ className: (0, css_1.cx)(name, className) }, rest)));
};
exports.default = Icon;
